import React, { Component } from "react";
// import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { isIE11, isMobile } from "../../userAgentDetect";
import reactGA from "../../reactGA";

import { GooglePlayBadge } from "../../components/AppBadges";
import { NotSupportDialog, YoutubeDialog } from "../../components/Dialogs";
import FreeCopyDialog from "../../components/Dialogs/FreeCopyDialog";
import CallToActionFooter from "../../components/CallToActionFooter";
import Hero from "./Hero";
import WhyUs from "./WhyUs";
import HomeSection from "../../components/HomeSection";

let AppPromote = ({ classes }) => (
  <div className={classes.container}>
    <h4 className={classes.text}>Download app now.</h4>
    <GooglePlayBadge />
  </div>
);
AppPromote = withStyles({
  container: {
    padding: 48,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  text: {
    maxWidth: 314,
    fontWeight: 300,
    lineHeight: "1.7em",
    marginRight: 32
  }
})(AppPromote);
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      youtubeDialogOpen: false,
      notSupportDialogOpen: true,
      freeCopyDialogOpen: false
    };
  }
  handleTryOpen = () => {
    reactGA.modalview("free-copy");
    this.setState({
      freeCopyDialogOpen: true
    });
  };
  handleDialogClose = name => () => {
    this.setState({ [`${name}DialogOpen`]: false });
  };
  handleHowToVideoOpen = () => {
    reactGA.modalview("how-to-video");
    this.setState({
      youtubeDialogOpen: true
    });
  };
  scrollTo = dest => () => {
    if (dest.current === null) return;
    dest.current.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  render() {
    const {
      youtubeDialogOpen,
      notSupportDialogOpen,
      freeCopyDialogOpen
    } = this.state;
    return (
      <div>
        <Hero
          onHowToVideoClick={this.handleHowToVideoOpen}
          onTryClick={this.handleTryOpen}
        />
        <WhyUs />
        <HomeSection
          imageLarge="https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto/v1542707733/mondaybee/assets/TimeCapsule2018CloseUp.png"
          imageSmall="https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_19/v1542707733/mondaybee/assets/TimeCapsule2018CloseUp.png"
          title="time travel"
          desc="Our one-of-a-kind time capsule mosaic offers you and your loved ones a magical journey to the past."
        />
        <HomeSection
          imageLarge="https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto/v1542707733/mondaybee/assets/TimeCapsulePosterAtHome.png"
          imageSmall="https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_19/v1542707733/mondaybee/assets/TimeCapsulePosterAtHome.png"
          reverse
          title="ARTSY DECOR"
          desc="We offer original mosaic designs for you to easily transform your memories into artworks. "
        />
        <CallToActionFooter />
        {/* ---------- Dialogs ---------- */}
        <FreeCopyDialog
          seeProductLink={true}
          open={freeCopyDialogOpen}
          onClose={this.handleDialogClose("freeCopy")}
        />
        <YoutubeDialog
          open={youtubeDialogOpen}
          onClose={this.handleDialogClose("youtube")}
          videoId="-CkcSZVKoko"
          label="How-to video"
          description="create photo mosaic with mondaybee"
        />
        {isIE11 && (
          <NotSupportDialog
            open={notSupportDialogOpen}
            onClose={this.handleDialogClose("notSupport")}
          />
        )}
      </div>
    );
  }
}

// const mapStateToProps = state => ({
//   gotFreeCopy: state.getFreeCopySuccess
// });

export default Home;



// WEBPACK FOOTER //
// ./src/screens/Home/index.js